// TODO(HABITS-328): Remove this hook after V2 1:1s GA rollout
import { useCurrentCompany } from './use-current-company';

const isDevelopment = process.env.NODE_ENV === 'development';

/**
 * TEMPORARY: Hook to check if the current user can access V2 1:1 features.
 *
 * V2 access is granted to:
 * - Bonusly company users (is_bonusly_company)
 * - Local development environments (for testing)
 *
 * This hook centralizes the V2 access pattern and should be used
 * consistently across all V2 1:1 feature checks.
 *
 * @see HABITS-328 - Remove after V2 GA rollout to all companies
 */
export const useCanAccessV2 = (): boolean => {
	const company = useCurrentCompany();
	return !!company?.is_bonusly_company || isDevelopment;
};
